import React from 'react';

import { IdentifyButton } from './styles';

interface OverflowButtonProps {
	count: number;
	disabled?: boolean;
	onClick: () => void;
}

export function OverflowButton({ count, disabled = false, onClick }: Readonly<OverflowButtonProps>): JSX.Element {
	return (
		<IdentifyButton disabled={disabled} onClick={onClick}>
			{`+${count}`}
		</IdentifyButton>
	);
}
